var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('server-type-generic',{attrs:{"server":_vm.server}})}
var staticRenderFns = []

export { render, staticRenderFns }